"use client";

import { useEffect, useState, useRef } from "react";
import { useParams } from "next/navigation";
import Image from "next/image";
import HeaderInner from "@/components/HeaderInner";
import * as ReactDOM from "react-dom";
import { getUserInfo } from "../../../../utilities/userInfo";
import FilterBar from "@/app/cin_booking_engine/Filterbar";
import { BookingEngineProvider } from "@/app/cin_context/BookingEngineContext";
import TigerLoader from "@/components/TigerLoader";
import OffersSlider from "./offerPageSlider";

export default function HotelOffers() {
  const [offersData, setOffersData] = useState([]);
  const [propertyData, setPropertyData] = useState([]);
  const [propertyId, setPropertyId] = useState(null);
  const { propertySlug } = useParams();
  const [loading, setLoading] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showFilterBar, setShowFilterBar] = useState(false);
  const filterBarRef = useRef(null);
  const [staahPropertyId, setStaahPropertyId] = useState(null);
  const [cityDetails, setCityDetails] = useState(null);
  const [modalContent, setModalContent] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [brandId, setBrandId] = useState(null);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [brandData, setBrandData] = useState([]);
  const [callBookNow, setCallBookNow] = useState(false);
  const [isHandleSearchProp, setHandleSearchProp] = useState(false);
  const [staahOfferId, setStaahOfferId] = useState(0);

  const brandColors = {
    1: "#bf1e2d",
    4: "#bf1e2d",
    2: "#263997",
    3: "#f04e02",
    5: "#febb19",
    6: "#f9e12e",
  };

  const backgroundColor = brandColors[brandId] || "#f26624";

  useEffect(() => {
    typeof window !== "undefined" && window.scrollTo(0, 0);
    const storedBrandId = localStorage.getItem("brandId");
    setBrandId(storedBrandId);
  }, []);

  useEffect(() => {
    if (!propertySlug) return;

    const fetchPropertyIdFromSlug = async (slug) => {
      try {
        const res = await fetch(
          `${process.env.NEXT_PUBLIC_ORANGE_TIGER_BASE_URL}/Api/property/GetPropertyList`,
        );
        const json = await res?.json();
        if (json.errorMessage !== "success") {
          console.error("Property list fetch error:", json);
          return null;
        }
        const found = json.data.find((p) => p.propertySlug === propertySlug);
        setPropertyData(found);
        setCityDetails({
          label: found?.cityName,
          value: found?.cityId,
          property_Id: found?.staahPropertyId,
        });
        setStaahPropertyId(found?.staahPropertyId);
        return found?.propertyId || null;
      } catch (error) {
        console.error("Error fetching property list:", error);
        return null;
      }
    };

    const loadPropertyId = async () => {
      setLoading(true);
      const id = await fetchPropertyIdFromSlug(propertySlug);
      setPropertyId(id);
      setLoading(false);
    };

    loadPropertyId();
  }, [propertySlug]);

  // Fetch brand data
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(
          `${process.env.NEXT_PUBLIC_ORANGE_TIGER_BASE_URL}/Api/property/GetBrandList`,
        );
        const json = await res.json();
        setBrandData(json.data || []);
      } catch (e) {
        console.error("Error fetching brands:", e);
      }
    })();
  }, []);

  useEffect(() => {
    const fetchOffersDetails = async () => {
      try {
        const res = await fetch(
          `${process.env.NEXT_PUBLIC_ORANGE_TIGER_BASE_URL}/Api/offers/GetOffersByProperty?propertyId=${propertyId}`,
        );
        const json = await res.json();
        if (
          json?.errorCode === "0" &&
          Array.isArray(json.data) &&
          json.data.length > 0
        ) {
          setOffersData(json.data?.[0]?.offersInfo);
        } else {
          console.warn("No data found in API");
          setOffersData([]);
        }
      } catch (err) {
        console.error("Error fetching dining details:", err);
        setOffersData([]);
      } finally {
        setIsPageLoading(false);
      }
    };

    fetchOffersDetails();
  }, [propertyId]);

  useEffect(() => {
    const storedBrandId = localStorage.getItem("brandId");
    setBrandId(storedBrandId);
  }, []);

  const handlePropertyBookNow = async (prop) => {
    if(Number(prop?.propertyOfferId || "0") > 0 ){

    setStaahOfferId(prop?.propertyOfferId);
    }
    else{
      
    setStaahOfferId(0);
    }
    setOpen(!isOpen);
    setShowFilterBar(!showFilterBar);
    setHandleSearchProp(true);
    if (filterBarRef.current) {
      filterBarRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      const firstInput = filterBarRef.current.querySelector(
        "input, select, button",
      );
      if (firstInput) firstInput.focus();
    }
  };

  const handleKnowMore = (offer) => {
    setModalContent({
      title: offer.offerTitle || offer.offerName,
      description:
        offer.internalDescription ||
        offer.offerDesc ||
        "No detailed description available.",
    });
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  async function postBookingWidged(
    rooms,
    mapping,
    isClose,
    ctaName,
    selectedPropertyId,
  ) {
    const resp = await getUserInfo();
    const sessionId = sessionStorage?.getItem("sessionId");
    const payload = {
      ctaName: ctaName,
      urls: window.location.href,
      cityId: "0",
      propertyId: selectedPropertyId?.toString() || "0",
      checkIn: "",
      checkOut: "",
      adults: "0",
      children: "0",
      rooms: "0",
      promoCode: "",
      ip: resp?.ip,
      sessionId: sessionId,
      deviceName: resp?.deviceInfo?.deviceName,
      deviceType:
        resp?.deviceInfo?.deviceOS == "Unknown"
          ? resp?.deviceInfo?.platform
          : resp?.deviceInfo?.deviceOS,
      roomsName: rooms?.RoomName,
      packageName: mapping?.MappingName,
      isCartOpen: mapping?.MappingName ? "Y" : "N",
      isCartEdit: "N",
      isCartClick: "N",
      isClose: isClose ? "Y" : "N",
    };
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_CMS_BASE_URL}/Api/tracker/BookingWidged`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      },
    );
    const res = await response?.json();
  }

  if (isPageLoading) {
    return <TigerLoader />;
  }

  return (
    <main className="bg-white" style={{ overflowY: "auto" }}>
      {/* Banner Image */}
      <HeaderInner
        brandData={brandData}
        propertyData={propertyData}
        brandId={brandId}
        backgroundColor={backgroundColor}
        propertyId={propertyData?.propertyId}
        onClick={handlePropertyBookNow}
      />
      {/* <HotelBookingBanner /> */}
      <section ref={filterBarRef} className="position-relative">
        <section
          className="position-fixed start-0 w-100 bg-white shadow"
          ref={filterBarRef}
        >
          {showFilterBar &&
            typeof window !== "undefined" &&
            ReactDOM.createPortal(
              <section className="filter-bar-hotels-cin">
                <BookingEngineProvider>
                  <FilterBar
                    selectedProperty={parseInt(cityDetails?.property_Id)}
                    cityDetails={cityDetails}
                    openBookingBar={showFilterBar}
                    onClose={(isReload) => {
                      setOpen(false);
                      setShowFilterBar(false);
                      if (isReload) {
                        window.location.reload();
                      }
                    }}
                    isCloseButtonShow="true"
                    backgroundColor={backgroundColor}
                    isHandleSearchProp={isHandleSearchProp}
                    staahOfferId={parseInt(staahOfferId)}
                  />
                </BookingEngineProvider>
              </section>,
              document.body,
            )}
        </section>
      </section>

      {/* Top Banner */}
      <div style={{ paddingTop: "80px" }}></div>

      {/* Intro */}

      <OffersSlider
        offersData={offersData}
        backgroundColor={backgroundColor}
        onExplore={handleKnowMore}
        onBookNow={handlePropertyBookNow}
      />

      {isModalOpen &&
        typeof window !== "undefined" &&
        ReactDOM.createPortal(
          <div
            className="modal fade show new-type-popup"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
            tabIndex="-1"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body">
                  <h6 className="modal-title" id="offerModalLabel">
                    {modalContent.title}
                  </h6>
                  <button
                    type="button"
                    className="btn-close modal-close-btn-in-body"
                    onClick={handleCloseModal}
                    aria-label="Close"
                    style={{ backgroundColor: backgroundColor }}
                  >
                    x
                  </button>
                  <div
                    className="p-3 offer-description html-content"
                    dangerouslySetInnerHTML={{
                      __html: modalContent.description || "",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>,
          document.body,
        )}
    </main>
  );
}
